import moment from "moment";
import { capitalizeFirstLetter } from "../string";

export const formatDateMonthYear = (date: Date) => {
  return capitalizeFirstLetter(moment(date).format("MMM YYYY"));
};
